module.exports = __webpack_public_path__ + "media/dogs/dog-wagging-tail--sprite-e080565f.svg";